(() => {
  const FAVORITES_KEY = 'sweb-favorites-v1';
  const RECENT_KEY = 'sweb-recent-v1';
  const read = (key) => { try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch { return []; } };
  const write = (key, value) => localStorage.setItem(key, JSON.stringify(value));
  const favorites = () => read(FAVORITES_KEY);
  const escapeText = (value) => String(value || '');

  function updateFavorites() {
    const saved = favorites();
    document.querySelectorAll('[data-sweb-favorite]').forEach((button) => {
      const active = saved.some((item) => item.handle === button.dataset.handle);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', active ? 'Favorilerden çıkar' : 'Favorilere ekle');
    });
    document.querySelectorAll('[data-sweb-favorites-count]').forEach((node) => {
      node.textContent = saved.length;
      node.hidden = saved.length === 0;
    });
    const list = document.querySelector('[data-sweb-favorites-list]');
    if (!list) return;
    list.replaceChildren();
    if (!saved.length) {
      const empty = document.createElement('p'); empty.className = 'sweb-favorites__empty'; empty.textContent = 'Henüz favori ürün eklenmedi.'; list.append(empty); return;
    }
    saved.forEach((item) => {
      const li = document.createElement('li'); const link = document.createElement('a'); link.href = item.url;
      const img = document.createElement('img'); img.src = item.image; img.alt = '';
      const span = document.createElement('span'); span.textContent = item.title;
      link.append(img, span); li.append(link); list.append(li);
    });
  }

  function toast(message, href) {
    const node = document.querySelector('[data-sweb-toast]'); if (!node) return;
    node.replaceChildren(document.createTextNode(message));
    if (href) {
      const link = document.createElement('a');
      link.href = href;
      link.textContent = 'Sepete git';
      node.append(document.createTextNode(' · '), link);
    }
    node.hidden = false; clearTimeout(window.__swebToastTimer);
    window.__swebToastTimer = setTimeout(() => { node.hidden = true; }, 4200);
  }

  document.addEventListener('click', (event) => {
    const favorite = event.target.closest('[data-sweb-favorite]');
    if (favorite) {
      event.preventDefault(); event.stopPropagation();
      const saved = favorites(); const index = saved.findIndex((item) => item.handle === favorite.dataset.handle);
      if (index >= 0) saved.splice(index, 1); else saved.unshift({handle:favorite.dataset.handle,title:favorite.dataset.title,url:favorite.dataset.url,image:favorite.dataset.image});
      write(FAVORITES_KEY, saved.slice(0, 30)); updateFavorites(); toast(index >= 0 ? 'Favorilerden çıkarıldı.' : 'Favorilere eklendi.'); return;
    }
    const open = event.target.closest('[data-sweb-favorites-open]');
    if (open) { event.preventDefault(); updateFavorites(); document.querySelector('[data-sweb-favorites]')?.showModal(); return; }
    const close = event.target.closest('[data-sweb-favorites-close]');
    if (close) document.querySelector('[data-sweb-favorites]')?.close();
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-sweb-add-form]'); if (!form) return;
    event.preventDefault(); const submit = form.querySelector('[type="submit"]'); if (submit?.disabled) return;
    if (submit) submit.disabled = true;
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', { method:'POST', headers:{Accept:'application/json'}, body:new FormData(form) });
      if (!response.ok) throw new Error('add failed');
      const cart = await fetch(window.Shopify.routes.root + 'cart.js').then((item) => item.json());
      document.querySelectorAll('[data-sweb-cart-count]').forEach((node) => { node.textContent = cart.item_count; node.hidden = cart.item_count === 0; });
      toast('Ürün sepete eklendi.', (window.Shopify.routes.root || '/') + 'cart');
    } catch { toast('Ürün sepete eklenemedi. Lütfen tekrar deneyin.'); }
    finally { if (submit) submit.disabled = false; }
  });

  document.addEventListener('sweb:content', updateFavorites);
  const current = document.querySelector('[data-sweb-current-product]');
  if (current) {
    const recent = read(RECENT_KEY).filter((item) => item.handle !== current.dataset.handle);
    recent.unshift({handle:current.dataset.handle,title:current.dataset.title,url:current.dataset.url,image:current.dataset.image,price:Number(current.dataset.price),currency:current.dataset.currency});
    write(RECENT_KEY, recent.slice(0, 8));
  }
  const recentGrid = document.querySelector('[data-sweb-recent]');
  if (recentGrid) {
    const recent = read(RECENT_KEY).slice(0, 4); const empty = recentGrid.parentElement.querySelector('[data-sweb-recent-empty]');
    if (recent.length) { if (empty) empty.hidden = true; }
    recent.forEach((item) => {
      const article = document.createElement('article'); article.className = 'sweb-card';
      const link = document.createElement('a'); link.className = 'sweb-card__link'; link.href = item.url;
      const media = document.createElement('div'); media.className = 'sweb-card__media'; const img = document.createElement('img'); img.src = item.image; img.alt = item.title; media.append(img);
      const body = document.createElement('div'); body.className = 'sweb-card__body'; const code = document.createElement('p'); code.className = 'sweb-code'; code.textContent = 'Son görüntülenen'; const title = document.createElement('h3'); title.textContent = item.title; const price = document.createElement('p'); price.className = 'sweb-card__price'; price.textContent = new Intl.NumberFormat('tr-TR',{style:'currency',currency:item.currency||'TRY'}).format(item.price/100);
      body.append(code,title,price); link.append(media,body); article.append(link); recentGrid.append(article);
    });
  }

  const lightbox = document.querySelector('[data-sweb-product-lightbox]');
  const lightboxImage = lightbox?.querySelector('[data-sweb-lightbox-image]');
  document.querySelectorAll('[data-sweb-product-zoom]').forEach((button) => button.addEventListener('click', () => {
    if (lightboxImage && button.dataset.swebZoomSrc) {
      lightboxImage.src = button.dataset.swebZoomSrc;
      lightboxImage.alt = button.dataset.swebZoomAlt || '';
    }
    lightbox?.showModal();
  }));
  document.querySelector('[data-sweb-product-zoom-close]')?.addEventListener('click', () => lightbox?.close());
  lightbox?.addEventListener('click', (event) => { if (event.target === lightbox) lightbox.close(); });

  document.querySelectorAll('[data-sweb-color-variant]').forEach((button) => {
    button.addEventListener('click', () => {
      document.querySelectorAll('[data-sweb-color-variant]').forEach((item) => item.setAttribute('aria-pressed', item === button ? 'true' : 'false'));
      const input = document.querySelector('[data-sweb-variant-id]');
      if (input) input.value = button.dataset.variantId;
      const sku = document.querySelector('[data-sweb-variant-sku]');
      if (sku) sku.textContent = button.dataset.sku || '';
      document.querySelectorAll('[data-sweb-media-color]').forEach((media) => {
        media.hidden = Boolean(media.dataset.swebMediaColor) && media.dataset.swebMediaColor !== button.dataset.color;
      });
      const url = new URL(window.location.href);
      url.searchParams.set('variant', button.dataset.variantId);
      window.history.replaceState({}, '', url);
    });
  });
  const initialColor = document.querySelector('[data-sweb-color-variant][aria-pressed="true"]');
  if (initialColor) initialColor.click();

  const variantSelect = document.querySelector('[data-sweb-variant-select]');
  if (variantSelect) {
    const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'tr-TR', { style:'currency', currency:window.Shopify?.currency?.active || 'TRY' }).format(Number(cents || 0) / 100);
    const updateVariant = () => {
      const option = variantSelect.options[variantSelect.selectedIndex];
      const available = option.dataset.available === 'true';
      const input = document.querySelector('[data-sweb-variant-id]');
      const submit = document.querySelector('[data-sweb-variant-submit]');
      const price = document.querySelector('[data-sweb-variant-price]');
      const compare = document.querySelector('[data-sweb-variant-compare]');
      const sku = document.querySelector('[data-sweb-variant-sku]');
      const stock = document.querySelector('[data-sweb-variant-stock]');
      if (input) input.value = option.value;
      if (submit) submit.disabled = !available;
      if (price) price.textContent = money(option.dataset.price);
      const compareValue = Number(option.dataset.compare || 0);
      if (compare) {
        compare.hidden = compareValue <= Number(option.dataset.price || 0);
        const strike = compare.querySelector('s'); if (strike) strike.textContent = compareValue ? money(compareValue) : '';
      }
      if (sku) sku.textContent = option.dataset.sku || '';
      if (stock) stock.textContent = available ? 'Siparişe açık' : 'Stokta yok; stok ve üretim bilgisini sorabilirsiniz';
      const media = option.dataset.mediaId ? document.querySelector(`[data-sweb-media-id="${CSS.escape(option.dataset.mediaId)}"]`) : null;
      media?.scrollIntoView({ behavior:'smooth', block:'nearest' });
      const url = new URL(window.location.href); url.searchParams.set('variant', option.value); window.history.replaceState({}, '', url);
    };
    variantSelect.addEventListener('change', updateVariant);
  }

  const backToTop = document.querySelector('[data-sweb-back-to-top]');
  if (backToTop) {
    const page = document.querySelector('.page-wrapper');
    const position = () => Math.max(window.scrollY, page?.scrollTop || 0);
    const update = () => { backToTop.hidden = position() < 700; };
    window.addEventListener('scroll', update, { passive: true });
    page?.addEventListener('scroll', update, { passive: true });
    backToTop.addEventListener('click', () => {
      if (page && page.scrollTop > 0) page.scrollTo({ top: 0, behavior: 'smooth' });
      else window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    update();
  }
  updateFavorites();
})();
